import { useMutation } from '@tanstack/react-query';
import { useRouter } from 'next/router';

import { $api, errorHandler, globalConst } from '../../global';

export const useStartVirtualTest = () => {
  const { push } = useRouter();

  return useMutation({
    mutationFn: async ({ language, blok1, blok2 }: { language: number; blok1?: number; blok2?: number }) => {
      const res = await $api.post('/virtual', { language, blok_1: blok1, blok_2: blok2 });

      return res.data;
    },
    onSuccess: () => {
      push(globalConst.pageNames.VIRTUAL_TEST);
    },
    onError: errorHandler()
  });
};
